import type { CaseCreateParams } from '../dto/case-create.dto';
import type { CaseMaindataArchiveCreateParams, CaseMainDataParams } from '../dto/case.dto';
import { transmute } from '@/shared';

function trimOrUndefined(v: unknown): string | undefined {
  const s = String(v ?? '').trim();
  return s || undefined;
}

export class CaseCreateMapper {
  static toMainDataParams(params: CaseCreateParams): CaseMainDataParams {
    const form = params;
    return transmute<CaseMainDataParams>(form, [
      { key: 'name', defaultVal: '' },
      { key: 'ga_hospital_id', from: 'hospitalId', defaultVal: null },
      { key: 'ga_hospital_department_id', from: 'departmentId', defaultVal: null },
      { key: 'ga_hospital_department_category_id', from: 'departmentCategoryId', defaultVal: null },
      { key: 'ga_doctor_id', from: 'doctorId', defaultVal: null },
      { key: 'ga_site_id', from: 'siteId', defaultVal: null },
    ]);
  }

  static toArchiveCreateParams(params: CaseCreateParams): CaseMaindataArchiveCreateParams {
    const form = params;
    const bodyPartId = Number(form.bodyPartId ?? 0);
    const indicationId = Number(form.indicationId ?? 0);
    const treatmentPlanId = Number(form.treatmentPlanId ?? 0);

    return transmute<CaseMaindataArchiveCreateParams>(form, [
      { key: 'name', from: 'patientName', transform: trimOrUndefined },
      { key: 'gender', defaultVal: undefined },
      { key: 'age', from: 'age', transform: v => trimOrUndefined(String(v ?? '')) },
      { key: 'id_number', from: 'idNumber', transform: trimOrUndefined },
      { key: 'blood_type', from: 'bloodType', transform: trimOrUndefined },
      { key: 'admission_diagnosis', from: 'admissionDiagnosis', transform: trimOrUndefined },
      { key: 'visit_no', from: 'visitNo', transform: trimOrUndefined },
      { key: 'hospitalization_number', from: 'hospitalizationNumber', transform: trimOrUndefined },
      { key: 'admission_time', from: 'admissionTime', transform: v => trimOrUndefined(String(v ?? '')) },
      { key: 'is_hospitalized', from: 'isHospitalized', transform: v => (v ? '1' : '0') },
      { key: 'bodypart_id', from: 'bodyPartId', transform: () => (bodyPartId > 0 ? bodyPartId : undefined) },
      { key: 'indication_id', from: 'indicationId', transform: () => (indicationId > 0 ? indicationId : undefined) },
      { key: 'treatment_plan_id', from: 'treatmentPlanId', transform: () => (treatmentPlanId > 0 ? treatmentPlanId : undefined) },
      { key: 'remark', from: 'remark', transform: trimOrUndefined },
      { key: 'province_id', from: 'provinceId', transform: trimOrUndefined },
      { key: 'province', from: 'province', transform: trimOrUndefined },
      { key: 'city_id', from: 'cityId', transform: trimOrUndefined },
      { key: 'city', from: 'city', transform: trimOrUndefined },
      { key: 'county_id', from: 'countyId', transform: trimOrUndefined },
      { key: 'county', from: 'county', transform: trimOrUndefined },
      { key: 'town_id', from: 'townId', transform: trimOrUndefined },
      { key: 'town', from: 'town', transform: trimOrUndefined },
    ]);
  }
}
